export const GET_MULTIPLE_PM_SECTIONS = 'GET_MULTIPLE_PM_SECTIONS'
export const GET_PM_SECTION = 'GET_PM_SECTION'
export const SET_PM_SECTION = 'SET_PM_SECTION'
export const SET_PM_SECTION_DONE = 'SET_PM_SECTION_DONE'
export const SET_PM_SECTION_PROCESSING = 'SET_PM_SECTION_PROCESSING'
export const SET_PM_SECTION_ERROR = 'SET_PM_SECTION_ERROR'
export const DELETE_PM_SECTION = 'DELETE_PM_SECTION'
export const DELETE_MULTIPLE_PM_SECTIONS = 'DELETE_MULTIPLE_PM_SECTIONS'

export function getMultiplePmSections (options = {}) {
  const { sectionIds, screenType, limit } = options
  return {
    type: GET_MULTIPLE_PM_SECTIONS,
    payload: { sectionIds, screenType, limit },
  }
}

export function getPmSection (options = {}) {
  const { sectionId, screenType, processing = true } = options
  return {
    type: GET_PM_SECTION,
    payload: { sectionId, screenType, processing },
  }
}

export function setPmSection (options = {}) {
  const {
    sectionId, data, processing = false, done = true,
  } = options
  return {
    type: SET_PM_SECTION,
    payload: {
      sectionId,
      data,
      processing,
      done,
    },
  }
}

export function setPmSectionDone (sectionId, done = true) {
  return {
    type: SET_PM_SECTION_DONE,
    payload: { sectionId, done },
  }
}

export function setPmSectionProcessing (sectionId, processing = true) {
  return {
    type: SET_PM_SECTION_PROCESSING,
    payload: { sectionId, processing },
  }
}

export function setPmSectionError (sectionId, error) {
  return {
    type: SET_PM_SECTION_ERROR,
    payload: {
      sectionId,
      error,
    },
  }
}

export function deletePMSection (sectionId) {
  return {
    type: DELETE_PM_SECTION,
    payload: {
      sectionId,
    },
  }
}

export function deleteMultiplePMSections (sectionIds) {
  return {
    type: DELETE_MULTIPLE_PM_SECTIONS,
    payload: {
      sectionIds,
    },
  }
}
